import styled from 'styled-components';

export const ListItemRoot = styled.li`
  display: flex;
`;

export const IconButtonRoot = styled.div`
  margin: auto;
`;
